import { APICallV3Get } from 'api/APICall';

export class PurchasedGiftsAPICall extends APICallV3Get {
    _method = 'billing/gift/giving';
}
